import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import XLSX from "xlsx";
import { getClientDomain, getUser, getToken, round, translate, parseExcel } from "../../../../utils/Common";
import { useForm } from "react-hook-form";
import Spinner from "../../../../components/Spinner";
import AuthContext from "../../../../contexts/auth";
import ModalContext from "../../../../contexts/modal";
import ProviderList from "../../../../components/ProviderList";
import { SiMicrosoftexcel } from "react-icons/si";
import TipoPaqueteSwitch from "../TipoPaqueteSwitch";
import ClientsSearchList from "../../../../components/ClientsSearchList";
import PageContainer from "../../../../components/layout/PageContainer";
import PageHeader from "../../../../components/layout/PageHeader";
import ContentCard from "../../../../components/layout/ContentCard";
import { FaBoxOpen, FaTimes, FaSave } from "react-icons/fa";
import Button from "../../../../components/common/Button";
import Table from "../../../../components/data/Table";
import { verifyAccessViewPermissions } from "../../../../config/permissions";
import "./index.css";
import styles from "./CargaMasiva.module.css";



// componente para hacer la carga masiva
const CargaMasiva = (props) => {
  const location = useLocation();
  const userContext = useContext(AuthContext);
  const modalContext = useContext(ModalContext);
  const country = localStorage.getItem("country");
  const { register, errors, setError, clearErrors, setValue } = useForm();

  const canCreate = verifyAccessViewPermissions(["create"], { path: location.pathname });
  const canSearch = verifyAccessViewPermissions(["search"], { path: location.pathname });
  const canUpload = verifyAccessViewPermissions(["upload"], { path: location.pathname });

  // variables from excel
  const [file, setFile] = useState(null);
  const [excelTableConfig, setExcelTableConfig] = useState(null);
  const [resultTableConfig, setResultTableConfig] = useState(null);
  // const [excelData, setExcelData] = useState(null);
  const [providor, setProvidor] = useState(null);
  const [idTipoPaquete, setIdTipoPaquete] = useState(2); 

  // show message about error
  const [isErrorUploading, setIsErrorUploading] = useState(false);
  let fileError = false;

  // tipo de usuario que se le va a realizar la carga
  const [idTipoUsuarioCarga, setIdTipoUsuarioCarga] = useState(
    userContext.user?.IsAdmin ? null : userContext.user?.IdTipoUsuario
  );

  const [uploadImage, setUploadImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [dataImage, setDataImage] = useState({ name: "", size: "", type: "" });

  // read file excel and render
  const handleFileUpload = (fileObj) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      const resp = parseExcel(sheetData);

      let newRows = [];
      let newCols = [];

      if (fileError) {
        setError('file', {
          type: '',
          message: translate("dashboard.packages.load.uploadFile.fileDistintic")
        });
        return;
      } else {
        if (!validateFile(resp)) {
          setError('file', {
            type: '',
            message: translate("dashboard.packages.load.uploadFile.fileDistintic")
          });
          return;
        }
      }

      resp.rows.map((row, index) => {
        if (row && row.length > 0) {
          if (index === 0) {
            newCols.push('#');
            if (userContext.user?.IsAdmin) newCols.push('USUARIO');
            getColumnOrder().forEach(col => newCols.push(col?.NombreCampoExcel.toUpperCase()));
            if (idTipoUsuarioCarga === 1) newCols.push('COSTOTOTAL');
          }
          else {
            switch (idTipoUsuarioCarga) {
              case 1:
                let data = {
                  usuario: userContext.user?.IsAdmin ? Number(selectedUser.IdUsuario) : userContext.user?.Ruc,
                  cliente: sheetData[index - 1]?.CLIENT ?? 'SIN CLIENTE',
                  tracking: sheetData[index - 1]?.TRACKING ?? 'SIN TRACKING',
                  pesoReal: sheetData[index - 1]["ACTUAL WEIGHT"] ?? 0,
                  pesoVol: sheetData[index - 1]["VOL WEIGHT"] ?? 0,
                  alto: sheetData[index - 1]?.HEIGHT ?? 0,
                  largo: sheetData[index - 1]?.LENGTH ?? 0,
                  ancho: sheetData[index - 1]?.WIDTH ?? 0,
                  paquete: sheetData[index - 1]?.PACKAGE ?? 'SIN NÚMERO',
                  plataforma: sheetData[index - 1]?.BOXIT ?? 'SIN PLATAFORMA',
                  precioLibra: round(Number(sheetData[index - 1]["POUND PRICE"]), 2) ?? 0,
                  costoProv: sheetData[index - 1]["COSTO PROV"] ?? 0
                }

                // validar qué peso se va a tomar
                if (data.pesoVol > 25) {
                  if (data.pesoVol > data.pesoReal) data.peso = data.pesoVol;
                  else data.peso = data.pesoReal;
                }
                else {
                  data.peso = data.pesoReal;
                }

                data.costoProv = round(data.peso * data.precioLibra, 2);

                newRows.push(data);
                // newRows.push(row);
                break;

              case 2:
                newRows.push({
                  usuario: userContext.user?.IsAdmin ? Number(selectedUser.IdUsuario) : userContext.user?.Ruc,
                  cliente: userContext.user?.IsAdmin ? selectedClient : userContext.user?.IdCliente,
                  paquete: sheetData[index - 1]?.PACKAGE ?? 'SIN NÚMERO',
                  tracking: sheetData[index - 1]?.TRACKING ?? 'SIN TRACKING',
                  plataforma: sheetData[index - 1]?.BOXIT ?? 'SIN PLATAFORMA',
                  email: sheetData[index - 1]?.EMAIL ?? 'SIN EMAIL',
                  estatus: 'NUEVO',
                  montoXPagar: sheetData[index - 1]?.AMOUNTPAY ?? 0,
                  alto: sheetData[index - 1]?.HEIGHT ?? 0,
                  largo: sheetData[index - 1]?.LENGTH ?? 0,
                  ancho: sheetData[index - 1]?.WIDTH ?? 0,
                });
                break;

              case 3:
                newRows.push({
                  usuario: userContext.user?.IsAdmin ? Number(selectedUser.IdUsuario) : userContext.user?.Ruc,
                  cliente: userContext.user?.IsAdmin ? selectedClient : userContext.user?.IdCliente,
                  // paquete: sheetData[index - 1]?.PAQUETE ?? 'SIN NÚMERO',
                  tracking: sheetData[index - 1]?.TRACKING ?? 'SIN TRACKING',
                  plataforma: sheetData[index - 1]?.BOXIT ?? 'SIN PLATAFORMA',
                  email: sheetData[index - 1]?.EMAIL ?? 'SIN EMAIL',
                  estatus: 'NUEVO',
                  montoXPagar: sheetData[index - 1]?.AMOUNTPAY ?? 0,
                  tamano: sheetData[index - 1]?.SIZE ?? 'SIN TAMAÑO',
                  descripcion: sheetData[index - 1]?.DESCRIPTION ?? 'SIN DESCRIPCIÓN'
                });
                break;

              default:
                break;
            }
          }
        }
        return false;
      });

      if (newRows.length === 0) {
        setError('file', {
          type: '',
          message: translate("dashboard.packages.load.uploadFile.noData")
        });
      }
      else {
        setFile({ cols: newCols, rows: newRows });
        const config = buildTableConfig({ package: { cols: newCols, rows: newRows } }, false);
        setExcelTableConfig(config);
        setIsErrorUploading(config?.hasErrors ?? false);
      }
    };
    reader.readAsBinaryString(fileObj);
  };

  // upload file and show it on screen
  const uploadFile = (e) => {
    try {
      setIsErrorUploading(false);
      fileError = false;

      if (userContext.user?.IsAdmin && !selectedUser) {
        setError("selectCompany", {
          type: "",
          message: translate(
            "dashboard.packages.load.uploadFile.selectCompany"
          ),
        });
        fileError = true;
      }

      let fileObj = e.target.files[0];

      if (!fileObj) {
        setError("file", {
          type: "",
          message: translate("dashboard.packages.load.uploadFile.fileObj"),
        });
        return;
      }

      if (
        !(
          fileObj.type === "application/vnd.ms-excel" ||
          fileObj.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        setError("file", {
          type: "",
          message: translate("dashboard.packages.load.uploadFile.file"),
        });
        return;
      }

      if (
        userContext.user?.IsAdmin &&
        idTipoUsuarioCarga > 1 &&
        !selectedClient
      ) {
        setError("file", {
          type: "",
          message: translate(
            "dashboard.packages.load.uploadFile.selectedClient"
          ),
        });
        return;
      }

      handleFileUpload(fileObj);

    } catch (error) {
      console.log(error);
      setError("file", {
        type: "",
        message: translate("dashboard.packages.load.uploadFile.errorUpload"),
      });
    }
  };

  const [isSendingData, setIsSendingData] = useState(false);
  // send data to server
  const registerData = async () => {
    try {
      setIsSendingData(true);
      loading(true);

      let data = { packages: file.rows };
      data.idTipoUsuario = idTipoUsuarioCarga;
      if (!userContext.user?.IsAdmin) {
        data.proveedor = userContext.user?.Ruc;
        data.cliente = userContext.user?.IdCliente;
      } else {
        data.proveedor = selectedUser.IdUsuario;
        if (selectedUser.IdTipoUsuario > 1)
          data.cliente = selectedClient;
        else data.cliente = 0;
      }

      data.idtipoPaquete = idTipoPaquete;

      const controller = new AbortController();
      const response = await fetch(
        `${getClientDomain(2)}/dashboard/packages/register/masiva`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify(data),
          signal: controller.signal,
        }
      );

      const result = await response.json();
      if (result) {
        if (result.code === 200 || result.code === 400) {
          if (result.message === "PACKAGES_LOADED") {
            // show message packages register successfully
            setFile(null);
            resetForm();
            modalContext.confirm(
              translate("dashboard.packages.load.uploadFile.modal.info"),
              translate("dashboard.packages.load.uploadFile.modal.success"),
              <button
                type="button"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
                onClick={() => modalContext.setIsOpenModal(false)}
              >
                {translate("global.accept")}
              </button>,
              true
            );
            setIsErrorUploading(false);
          } else if (result.message === "SOME_PACKAGES_NOT_LOADED") {
            const newCols = [...file.cols];
            newCols.shift();
            newCols.unshift("#", "MENSAJE");
            setExcelTableConfig(null);
            setResultTableConfig(
              buildTableConfig(
                { package: { cols: newCols, rows: result.packagesList } },
                true
              )
            );
            modalContext.confirm(
              translate("dashboard.packages.load.uploadFile.modal.attention"),
              translate("dashboard.packages.load.uploadFile.modal.noSuccess"),
              <button
                type="button"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
                onClick={() => modalContext.setIsOpenModal(false)}
              >
                {translate("global.accept")}
              </button>,
              true
            );
          }
        } else {
          resetForm();
          setFile(null);
          modalContext.confirm(
            translate("global.alerts.ops"),
            translate("dashboard.packages.load.uploadFile.modal.error"),
            <button
              type="button"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
              onClick={() => modalContext.setIsOpenModal(false)}
            >
              {translate("global.accept")}
            </button>,
            true
          );
        }
      } else {
        resetForm();
        setFile(null);
        modalContext.confirm(
          translate("global.alerts.ops"),
          translate("dashboard.packages.load.uploadFile.modal.error"),
          <button
            type="button"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
            onClick={() => modalContext.setIsOpenModal(false)}
          >
            {translate("global.accept")}
          </button>,
          true
        );
      }
    } catch (error) {
      console.log(error);
      resetForm();
      setFile(null);
      modalContext.confirm(
        translate("global.alerts.ops"),
        translate("dashboard.packages.load.uploadFile.modal.error"),
        <button
          type="button"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.accept")}
        </button>,
        true
      );
    } finally {
      setIsSendingData(false);
    }
  };

  // get column order
  const getColumnOrder = (col) => {
    let columnas = [];

    if (idTipoUsuarioCarga) {
      switch (idTipoUsuarioCarga) {
        case 1:
          columnas = supplierLoad; break;
        case 2:
          columnas = B2BLoad; break;
        case 3:
          columnas = entrepreneurLoad; break;
        default:
          break;
      }
    }

    return columnas;
  }

  // validar que el archivo sea el correcto
  const validateFile = (file) => {
    let columnas = file.rows[0];

    if (idTipoUsuarioCarga) {
      if (idTipoUsuarioCarga === 1) {
        if (equals(columnas, supplierLoad)) return true;
      } else if (idTipoUsuarioCarga === 2) {
        if (equals(columnas, B2BLoad)) return true;
      } else if (idTipoUsuarioCarga === 3) {
        if (equals(columnas, entrepreneurLoad)) return true;
      }
    }

    return false;
  };
  // Mapeo columna -> key y errorKey para el componente Table (mismo patrón que Search Packages)
  const COL_KEY_MAP = {
    '#': '_index',
    'USUARIO': 'usuario',
    'MENSAJE': 'resultado',
    'CLIENT': 'cliente',
    'TRACKING': 'tracking',
    'ACTUAL WEIGHT': 'pesoReal',
    'VOL WEIGHT': 'pesoVol',
    'HEIGHT': 'alto',
    'LENGTH': 'largo',
    'WIDTH': 'ancho',
    'PACKAGE': 'paquete',
    'BOXIT': 'plataforma',
    'POUND PRICE': 'precioLibra',
    'COSTOTOTAL': 'costoProv',
    'COSTO PROV': 'costoProv',
    'EMAIL': 'email',
    'AMOUNTPAY': 'montoXPagar',
    'SIZE': 'tamano',
    'DESCRIPTION': 'descripcion',
  };
  const COL_ERROR_KEYS = {
    'CLIENT': 'clienteError',
    'TRACKING': 'trackingError',
    'PACKAGE': 'packageError',
    'BOXIT': 'plataformaError',
    'POUND PRICE': 'precioLibraError',
    'EMAIL': 'emailError',
    'SIZE': 'sizeError',
    'MENSAJE': 'resultadoError',
  };

  const buildTableConfig = (data, result) => {
    if (!data?.package?.rows || data.package.rows === "No hay registros en el archivo") {
      return { tableData: [], tableColumns: [], hasErrors: false };
    }
    let hasErrors = false;
    const tableData = data.package.rows.map((row, index) => {
      const r = { ...row };
      let packageError, clienteError, trackingError, emailError, sizeError, precioLibraError = false;
      let plataformaError = idTipoUsuarioCarga === 1;

      if (!result) {
        if (idTipoUsuarioCarga !== 3 && r.paquete?.toUpperCase() === "SIN NÚMERO") packageError = true;
        if (r.tracking?.toUpperCase() === "SIN TRACKING") trackingError = true;

        if (idTipoUsuarioCarga !== 1) {
          if (avaliblePlatforms?.length) {
            avaliblePlatforms.forEach((boxit) => {
              if (boxit?.locationName?.toUpperCase().includes(r.plataforma?.toUpperCase())) {
                plataformaError = false;
                r.plataforma = boxit.locationName;
              }
            });
          }
          if (r.email?.toUpperCase() === "SIN EMAIL" || r.email?.indexOf?.("@") === -1) emailError = true;
          if (idTipoUsuarioCarga === 3 && !["P", "M", "G"].includes(r.tamano?.toUpperCase())) sizeError = true;
        } else {
          if (r.cliente?.toUpperCase() === "SIN CLIENTE") clienteError = true;
          if (!userContext.user?.IsAdmin && (r.precioLibra === 0 || r.precioLibra == null)) precioLibraError = true;
          plataformaError = false;
          if (r.plataforma === "") r.plataforma = "SIN PLATAFORMA";
        }
      } else {
        plataformaError = false;
        const msg = r.resultado || "";
        if (msg.includes("paquete ya se encuentra registrado")) packageError = true;
        else if (msg.includes("tracking ya se encuentra registrado")) trackingError = true;
        else if (msg.includes("ID del cliente no existe")) clienteError = true;
        else if (msg.includes("autorización para entregar")) plataformaError = true;
      }

      const _hasError = packageError || trackingError || emailError || sizeError || precioLibraError || clienteError || plataformaError;
      const _errors = {
        packageError, clienteError, trackingError, emailError, sizeError, precioLibraError, plataformaError,
        resultadoError: result && _hasError,
      };
      if (_hasError) hasErrors = true;
      return { ...r, _index: index, _errors, _hasError };
    });

    const tableColumns = (data.package.cols || []).map((colLabel) => {
      const key = COL_KEY_MAP[colLabel] ?? colLabel;
      const errorKey = COL_ERROR_KEYS[colLabel];
      return {
        key,
        label: colLabel,
        sortable: false,
        render: (row) => {
          const value = key === '_index' ? (row._index + 1) : (row[key] ?? "");
          const hasError = errorKey && row._errors?.[errorKey];
          return <span className={hasError ? styles.cellError : ""}>{value}</span>;
        },
      };
    });

    return { tableData, tableColumns, hasErrors };
  };

  // funcion para comparar dos arreglos
  const equals = (a, b) => {
    return a.length === b.length &&
      b.every(element =>
        a.includes(element.NombreCampoExcel) ? true : false
      );
  }

  // ordernar la posicion de los fields del excel format que vienen del server
  const ordenarServerExcelFields = (datos) => {
    for (let i = 0; i < datos.length - 1; i++) {
      for (let f = 0; f < datos.length - i - 1; f++) {
        if (datos[f].OrderFields > datos[f + 1].OrderFields) {
          let aux = datos[f];
          datos[f] = datos[f + 1];
          datos[f + 1] = aux;
        }
      }
    }

    return datos;
  };

  // reiniciar formulario y cancelar carga de paquetes
  const resetForm = () => {
    setFile(null);
    setResultTableConfig(null);
    setExcelTableConfig(null);
    clearErrors();
    setIsErrorUploading(false);
    setSelectedClient(null);
    setSelectedUser(null);
  };

  // para obtener los proveedores
  const [selectedUser, setSelectedUser] = useState(null);
  // handle change of company name

  const loading = () => {
    modalContext.confirm(
      "Cargando...",
      <div className="p-3 text-center">
        <Spinner type={1} size={15} />
      </div>,
      <button
        type="button"
        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
        onClick={() => modalContext.setIsOpenModal(false)}
      >
        {translate("global.accept")}
      </button>,
      true
    );
  };

  const getExcelFile = async () => {
    try {
      if (idTipoUsuarioCarga) {
        const response = await fetch(
          `${getClientDomain()}/files/xlsx/${idTipoUsuarioCarga}`,
          {
            method: "GET",
            accept: "application/json",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        const result = await response.json();
        if (result) {
          if (result.code === 200) {
            let wb = XLSX.utils.book_new(); //create new
            let ws = XLSX.utils.aoa_to_sheet(result.payload[0].fileModel); // crea una hoja de excel
            ws["!cols"] = result.payload[0].colProps; // nombre de las columnas
            XLSX.utils.book_append_sheet(wb, ws, result.payload[0].sheetName); //la hoja la mete dentro del libro
            XLSX.writeFile(wb, `${result.payload[0].fileName}.xlsx`); //crea el archivo
          } else {
            setError("file", {
              type: "",
              message: translate(
                "dashboard.packages.load.uploadFile.fileNotAvailable"
              ),
            });
          }
        } else {
          setError("file", {
            type: "",
            message: translate(
              "dashboard.packages.load.uploadFile.fileNotAvailable"
            ),
          });
        }
      } else
        setError("file", {
          type: "",
          message: translate("dashboard.packages.load.uploadFile.selectedUser"),
        });
    } catch (error) {
      console.log("error:", error);
    }
  };

  const getFileModel = async (value) => {
    try {
      if (value) {
        const response = await fetch(
          `${getClientDomain(2)}/dashboard/packages/file/${value}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${getToken()}`,
            },
          }
        );

        const result = await response.json();
        if (result) {
          if (result.payload) {
            if (result.payload.length > 0) {
              let campos = [];
              result.payload.map((col) => {
                campos.push(col);
                return false;
              });

              switch (value) {
                case 1:
                  setSupplierLoad(ordenarServerExcelFields(campos));
                  break;
                case 2:
                  setB2BLoad(ordenarServerExcelFields(campos));
                  break;
                case 3:
                  setEntrepreneurLoad(ordenarServerExcelFields(campos));
                  break;

                default:
                  break;
              }
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  // variables usadas para la busqueda del cliente
  const [selectedClient, setSelectedClient] = useState(null);

  // Get plataformas disponibles from server
  const [avaliblePlatforms, setAvaliblePlatforms] = useState([]);
  // para obtener el formato del archivo excel
  const [entrepreneurLoad, setEntrepreneurLoad] = useState([]);
  const [supplierLoad, setSupplierLoad] = useState([]);
  const [B2BLoad, setB2BLoad] = useState([]);

  // obtener las plataformas disponibles y el modelo del archivo excel
  useEffect(() => {
    const user = getUser();
    const token = getToken();
    const clientDomain = getClientDomain(2);
    const controller = new AbortController();

    const getFileInfo = async () => {
      if (sessionStorage.getItem("platforms")) {
        setAvaliblePlatforms(JSON.parse(sessionStorage.getItem("platforms")));
      } else {
        try {
          const response = await fetch(
            `${clientDomain}/dashboard/platforms/client`,
            {
              method: "GET",
              accept: "application/json",
              headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${token}`,
              },
              signal: controller.signal,
            }
          );

          const result = await response.json();
          if (result) {
            if (result.payload) {
              if (result.payload.length > 0) {
                setAvaliblePlatforms(result.payload);
                sessionStorage.setItem(
                  "platforms",
                  JSON.stringify(result.payload)
                );
              }
            }
          }
        } catch (err) {
          console.log(err);
        }
      }

      if (!user?.IsAdmin) {
        try {
          const response = await fetch(
            `${getClientDomain(2)}/dashboard/packages/file/${idTipoUsuarioCarga}`,
            {
              method: "GET",
              accept: "application/json",
              headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${token}`,
              },
              signal: controller.signal,
            }
          );

          const result = await response.json();
          
          if (result) {
            if (result.payload) {
              if (result.payload.length > 0) {
                let campos = [];
                result.payload.map((col) => {
                  campos.push(col);
                  return false;
                });
                switch (idTipoUsuarioCarga) {
                  case 1:
                    setSupplierLoad(ordenarServerExcelFields(campos));
                    break;
                  case 2:
                    setB2BLoad(ordenarServerExcelFields(campos));
                    break;
                  case 3:
                    setEntrepreneurLoad(ordenarServerExcelFields(campos));
                    break;

                  default:
                    break;
                }
              }
            }
          }
        } catch (err) {
          console.log(err);
        }
      }
    };

    getFileInfo();
    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (providor) {
      resetForm();
      setSelectedUser(providor ? providor : null);
      setIdTipoUsuarioCarga(providor ? providor.IdTipoUsuario : null);
      getFileModel(providor ? providor.IdTipoUsuario : null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providor]);
  return (
    <PageContainer>
      <PageHeader
        title={translate("sidebar.options.packages.load")}
        icon={<FaBoxOpen size={24} />}
      />

      <ContentCard padding="md">
        <form className={styles.form}>
          <TipoPaqueteSwitch idTipoPaquete={idTipoPaquete} setIdTipoPaquete={setIdTipoPaquete} />

          {canSearch && userContext.user?.IsAdmin && !file && (
            <>
              <p className={styles.sectionLabel}>
                {translate("dashboard.packages.load.uploadFile.title")}:
              </p>
              <div className={styles.sectionRow}>
                <div className={styles.selectWrapper}>
                  <label htmlFor="selectProveedor">
                    <span className="text-error font-semibold">*</span> {translate("global.business")}:
                  </label>
                  <ProviderList
                    register={register}
                    nameShow={translate("global.select")}
                    idShow={"all"}
                    idHide={country === 'br'}
                    readOnly={false}
                    setValue={setValue}
                    valueId={"proveedor"}
                    setProveedor={setProvidor}
                  />
                </div>
                {selectedUser?.IdTipoUsuario > 1 && !file && (
                  <div className={styles.selectWrapper}>
                    <label htmlFor="inputBuscarcliente">
                      {translate("global.search")} {translate("global.client")}:
                    </label>
                    <ClientsSearchList
                      idUsuarioSelected={selectedUser?.IdUsuario}
                      errors={errors}
                      setError={setError}
                      clearErrors={clearErrors}
                      register={register}
                      idTipoCliente={selectedUser.IdTipoUsuario > 1 ? 7 : 1}
                      setSelectOption={setSelectedClient}
                      autoSelectClient
                    />
                    {props.errors?.buscarCliente && (
                      <span className="text-destructive font-xsmall">{props.errors.buscarCliente.message}</span>
                    )}
                  </div>
                )}
              </div>
            </>
          )}

          {canUpload && !file && (
            <div className={styles.sectionRow}>
              <div>
                <p className={styles.sectionLabel}>
                  {translate("dashboard.packages.load.uploadFile.selectedExcel")}:
                </p>
                <div className={styles.fileUploadWrapper}>
                  <label htmlFor="inputFileName" className={styles.fileUploadLabel}>
                    <SiMicrosoftexcel size={20} />
                    {translate("global.attachFileExcel")} <span className="red-label">*</span>
                  </label>
                  <input
                    type="file"
                    onChange={uploadFile}
                    id="inputFileName"
                    accept=".xlsx"
                    name="file"
                    className={styles.fileInput}
                    ref={register}
                  />
                </div>
                {errors.datePayment && (
                  <p className={styles.errorText}>{errors.datePayment.message}</p>
                )}
                {errors.file && (
                  <span className={styles.errorText}>{errors.file.message}</span>
                )}
                <p className={styles.tableSectionTitle}>
                  {translate("dashboard.packages.load.uploadFile.lostModel")}{" "}
                  <span
                    className={styles.downloadLink}
                    onClick={() => getExcelFile()}
                    onKeyDown={(e) => e.key === 'Enter' && getExcelFile()}
                    role="button"
                    tabIndex={0}
                  >
                    {translate("dashboard.packages.load.uploadFile.download")}
                  </span>
                </p>
              </div>
            </div>
          )}

          {canUpload && file && (
            <div className={styles.tableSection}>
              <p className={styles.tableSectionTitle}>
                {translate("dashboard.packages.load.uploadFile.infoPackage")}
              </p>
              {excelTableConfig && (
                <Table
                  columns={excelTableConfig.tableColumns}
                  data={excelTableConfig.tableData}
                  emptyMessage={translate("global.noResults")}
                  sortable={false}
                  striped
                  hoverable
                  getRowClassName={(row) => (row._hasError ? styles.rowError : "")}
                />
              )}
              {resultTableConfig && (
                <Table
                  columns={resultTableConfig.tableColumns}
                  data={resultTableConfig.tableData}
                  emptyMessage={translate("global.noResults")}
                  sortable={false}
                  striped
                  hoverable
                  getRowClassName={(row) => (row._hasError ? styles.rowError : "")}
                />
              )}
            </div>
          )}

          {isErrorUploading && (
            <p className={styles.errorText}>
              {translate("dashboard.packages.load.uploadFile.errorLoadPackage")}
            </p>
          )}

          <div className={styles.actionsRow}>
            {file && excelTableConfig && (
              <>
                <Button
                  variant="outline"
                  type="button"
                  onClick={() => resetForm()}
                  className={styles.clearButton}
                  leftIcon={<FaTimes size={14} />}
                >
                  {isErrorUploading
                    ? translate("global.clean")
                    : translate("global.cancel")}
                </Button>
                {!isErrorUploading && canCreate && (
                  <Button
                    variant="primary"
                    type="button"
                    disabled={isSendingData}
                    loading={isSendingData}
                    onClick={() => registerData()}
                    className={styles.primaryButton}
                    leftIcon={<FaSave size={14} />}
                  >
                    {translate("global.register")}
                  </Button>
                )}
              </>
            )}
            {file && resultTableConfig && (
              <Button
                variant="outline"
                type="button"
                onClick={() => resetForm()}
                className={styles.clearButton}
                leftIcon={<FaTimes size={14} />}
              >
                {translate("global.clean")}
              </Button>
            )}
          </div>
        </form>
      </ContentCard>
    </PageContainer>
  );
};

export default CargaMasiva;
